import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getAllPrograms = createAsyncThunk("getAllPrograms", async () => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/program`
    );
    ;
    return data;
  } catch (error) {
    console.error(error);
  }
});

export const ProgramSlice = createSlice({
  name: "Programs",
  initialState: {
    allPrograms: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getAllPrograms.pending]: (state) => {
      state.status = "pending";
    },
    [getAllPrograms.fulfilled]: (state, action) => {
      state.status = "success";
      state.error = action.error;
      state.allPrograms = action.payload;
    },
    [getAllPrograms.rejected]: (state, action) => {
      state.status = "failed";
      state.allPrograms = null;
      state.error = action.error;
    },
  },
});

export default ProgramSlice.reducer;
